// Costa Rica driver's license barcode — identification comes prefixed by one of
// CI-, CI, DM-, DM (dash optional). We want the digits right after that marker,
// stopping at the next letter, e.g.:
//   CI-701590933B1              -> 701590933
//   CI701590933B1               -> 701590933
//   32423MDMCI701590933B1       -> 701590933
//   32423DMDMCI-701590933B122AD -> 701590933
//   DM701590933B1               -> 701590933
//   DM-701590933B1              -> 701590933
//   32423CIDM-701590933B1       -> 701590933
//   32423DMDDM701590933B122AD   -> 701590933

import { DEFAUTL_BASE64_START_CODE } from '../../../variables';

export const CR_LICENSE_REGEX = /(?:CI|DM)-?(\d+)/

export default function CRLicenseReader(code) {
  // Un payload binario (cédula PDF417) llega como "base64:..." y puede contener "CI3" por azar;
  // nunca es una licencia.
  const isBinaryPayload = code.startsWith(DEFAUTL_BASE64_START_CODE)
  const identification = (isBinaryPayload ? '' : code.match(CR_LICENSE_REGEX)?.[1] || '').trim()

  return { identification, first_name: '', last_name: '', last_name_two: '' }
}
